"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../schema");
const weight = schema_1.Schema.number()
    .expiration(31536000)
    .unit("kg")
    .precision(2)
    .max(999)
    .minExclusive(0)
    .interpretation({ vocab: "ktx", code: "weight" })
    .tag({ vocab: "snomed", code: "363808001" })
    .tag({ vocab: "loinc", code: "29463-7" })
    .tag({ vocab: "srtr", code: "can_most_recent_wgt_kg7" });
const height = schema_1.Schema.number()
    .unit("cm")
    .integer()
    .max(999)
    .minExclusive(0)
    .interpretation({ vocab: "ktx", code: "height" })
    .tag({ vocab: "snomed", code: "50373000" })
    .tag({ vocab: "loinc", code: "8302-2" })
    .tag({ vocab: "srtr", code: "can_hgt_cm" });
const bmi = schema_1.Schema.expression(`toPrecision({../weight} / ({../height} / 100) ** 2, 1)`)
    .expiration(7776000)
    .unit("kg/m2")
    .interpretation({ vocab: "ktx", code: "bmi" })
    .tag({ vocab: "snomed", code: "60621009" })
    .tag({ vocab: "loinc", code: "39156-5" });
const dubois = schema_1.Schema.expression(`toPrecision(0.007184 * {../../weight} ** 0.425 * {../../height} ** 0.725, 1)`)
    .expiration(7776000)
    .unit("m2")
    .interpretation({ vocab: "ktx", code: "bsa_dubois" })
    .tag({ vocab: "snomed", code: "128178001" })
    .tag({ vocab: "loinc", code: "3140-1" });
const monsteller = schema_1.Schema.expression(`toPrecision(0.016667 * {../../weight} ** 0.5 * {../../height} ** 0.5, 1)`)
    .expiration(7776000)
    .unit("m2")
    .interpretation({ vocab: "ktx", code: "bsa_monsteller" })
    .tag({ vocab: "snomed", code: "128178001" })
    .tag({ vocab: "loinc", code: "3140-1" });
const bsa = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ dubois, monsteller });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ weight, height, bmi, bsa })
    .interpretation({ vocab: "ktx", code: "antropometrics_examination" })
    .tag({ vocab: "fyrms", code: "action" });
